<template>
    <div class="global edit-user">
        <header class="global-header">
            <div class="line-item">
                <div class="user-avatar">
                    <md-avatar v-if="userToEdit.avatar" class="md-avatar-icon md-large">
                        <img :src="getImageSrc(userToEdit.avatar)">
                    </md-avatar>
                    <md-avatar v-else class="md-avatar-icon blue md-large">
                        {{ getUserInitials(userToEdit) }}
                    </md-avatar>
                </div>
                <div class="user-details">
                    <div class="user-name">{{ userToEdit.firstName + ' ' + userToEdit.lastName }}</div>
                    <div class="user-title">{{ userToEdit.title }}</div>
                </div>
                <md-button class="md-icon-button exit-user" @click="exitEditUser()">
                    <md-icon>clear</md-icon>
                </md-button>
            </div>
            <div class="line-item client-tabs btn-position-wrap">
                <md-tabs class="centered-title md-tabs-wrapper container" md-sync-route md-alignment="left">
                    <md-tab md-label="Profile" to="/user/profile"/>
                    <md-tab v-if="userToEdit.id === currentUser.id" md-label="Password" to="/user/password"/>
                </md-tabs>
            </div>
        </header>
        <div class="page-content">
            <div class="wrap">
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>
<script>
import {mapGetters, mapActions} from 'vuex';

export default {
  data: () => ({
    returnPath: ''
  }),
  computed: {
    ...mapGetters('user', ['userToEdit', 'currentUser'])
  },
  methods: {
    ...mapActions('user', ['clearUserToEdit']),
    getImageSrc (avatar) {
      return 'static/img/' + avatar;
    },
    getUserInitials (user) {
      let userInitials = '';
      if (user.firstName) {
        userInitials += user.firstName.charAt(0);
      }
      if (user.lastName) {
        userInitials += user.lastName.charAt(0);
      }
      if (userInitials.length < 1) {
        userInitials = 'NA';
      }
      return userInitials;
    },
    exitEditUser () {
      this.clearUserToEdit();
      this.$router.push(this.returnPath);
    }
  },
  mounted () {
    this.returnPath = this.$store.state.RouterModule.from.fullPath;
  }
};
</script>
<style lang="scss" scoped>
.user-avatar {
    display: inline-block;
    margin: 20px 20px 20px 30px;
}

.user-details {
    padding-top: 40px;
    position: absolute;
    display: inline-block;

    .user-name {
        font-size: 20px;
    }

    .user-title {
        font-size: 13px;
    }
}

.exit-user {
    float: right;
}

.edit-user .wrap {
    padding-left: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/settings/EditUser.vue